import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import {CardContainer, Input, Button, Tab, Notification, Loading} from 'components/common/uiKit';

import * as RouteService from 'services/route'
import {LessonApi} from 'services/network/api';

import {MainLesson, SubLesson} from './tabs';


const TabsData = [
    {
        key: 'Main',
        title: '',
        component: MainLesson
    },
    {
        key: 'Sub',
        title: '',
        component: SubLesson
    }
];

class Lesson extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lessonId: 0,
            title: '',
            data: [],
            id: 0,
            loading: true
        }

    }

    componentDidMount() {
        this.getLessonIdFromQs();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.onRouteChanged();
        }
    }

    onRouteChanged() {
        this.getLessonIdFromQs();
    }

    getLessonIdFromQs() {
        let lessonId = 0;

        const qs = RouteService.QueryStringService.getQyeryStrings();

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.Lesson.Tabs;

        if (!qs || !qs.lessonId) {
            Notification('error', 'WrongData');

            const {history} = this.props;
            history.goBack();
        }

        lessonId = qs.lessonId;

        let _tabsData = TabsData.map(x => {
            x.title = pageTranslates[x.key];
            return (Object.assign(x, {params: {lessonId}}));
        });

        this.setState({data: _tabsData, lessonId}, () => {
            this.loadData();
        });
    }

    loadData() {
        const {lessonId} = this.state;

        if (lessonId) {
            //TODO: use loading
            LessonApi.GetDetails(lessonId)
                .then(res => {
                    if (res && res.status == 200) {
                        let {data} = this.state;
                        const resData = res.data;
                        data.map(x => {
                            x.params = Object.assign(x.params, resData);
                            if (x.key == 'Sub') {
                                Object.assign(x, {disabled: (!resData.childs || resData.childs.length == 0)})
                            }
                        });
                        let {id} = this.state;
                        this.setState({data, id: ++id});
                    }
                }).finally(() => {
                this.setState({loading: false});
            })
        }
    }

    render() {
        const {id, loading} = this.state;

        if (loading)
            return <Loading/>;

        return (
            <div key={id}>
                <Tab data={TabsData}/>
            </div>
        );
    }
}


const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(Lesson));
